<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BottomNav from './components/BottomNav.vue';
import GlobalFeedback from './components/GlobalFeedback.vue';

const route = useRoute();
const nav = computed(() => Boolean(route.meta.bottomNav));
</script>

<template>
  <main class="app-shell" :class="{ 'with-nav': nav }">
    <RouterView />
  </main>
  <BottomNav v-if="nav" />
  <GlobalFeedback />
</template>
